module.exports = __webpack_public_path__ + "img/reentry-white@2x.c71816be.png";